import { Plugins } from '@leverege/plugin';
import Unit from '@leverege/unit';
import UnitBetweenComparator from './UnitBetweenComparator.js';
import UnitBetweenComparatorEditor from "./UnitBetweenComparatorEditor.js";
import UnitBetweenComparatorEvaluator from './UnitBetweenComparatorEvaluator.js';
import UnitEqualsCondition from './UnitEqualsComparator.js';
import UnitEqualsComparatorEditor from "./UnitEqualsComparatorEditor.js";
import UnitEqualsComparatorEvaluator from './UnitEqualsComparatorEvaluator.js';
import UnitGreaterThanComparator from './UnitGreaterThanComparator.js';
import UnitGreaterThanComparatorEditor from "./UnitGreaterThanComparatorEditor.js";
import UnitGreaterThanComparatorEvaluator from './UnitGreaterThanComparatorEvaluator.js';
import UnitGreaterThanOrEqualComparator from './UnitGreaterThanOrEqualComparator.js';
import UnitGreaterThanOrEqualComparatorEditor from "./UnitGreaterThanOrEqualComparatorEditor.js";
import UnitGreaterThanOrEqualComparatorEvaluator from './UnitGreaterThanOrEqualComparatorEvaluator.js';
import UnitLessThanComparator from './UnitLessThanComparator.js';
import UnitLessThanComparatorEditor from "./UnitLessThanComparatorEditor.js";
import UnitLessThanComparatorEvaluator from './UnitLessThanComparatorEvaluator.js';
import UnitNotEqualsComparator from './UnitNotEqualsComparator.js';
import UnitNotEqualsComparatorEditor from "./UnitNotEqualsComparatorEditor.js";
import UnitNotEqualsComparatorEvaluator from './UnitNotEqualsComparatorEvaluator.js';
import UnitLessThanOrEqualComparator from './UnitLessThanOrEqualComparator.js';
import UnitLessThanOrEqualComparatorEditor from "./UnitLessThanOrEqualComparatorEditor.js";
import UnitLessThanOrEqualComparatorEvaluator from './UnitLessThanOrEqualComparatorEvaluator.js';
export default {
  install(opts) {
    const types = Unit.getUnitTypes();
    types.forEach(type => {
      // const key = `${type[0].toUpperCase()}${type.substring( 1 )}`
      const eqModel = UnitEqualsCondition.createFor(type);
      const eqEditor = UnitEqualsComparatorEditor.createFor(type);

      // exports[`${key}EqualsComparator`] = eqModel
      Plugins.add('AttributeConditionComparator', eqModel);
      Plugins.add('AttributeConditionComparatorEditor', {
        type: eqModel.TYPE,
        editor: eqEditor
      });
      Plugins.add('ConditionEvaluator', {
        type: eqModel.TYPE,
        evaluator: UnitEqualsComparatorEvaluator
      });
      const gtModel = UnitGreaterThanComparator.createFor(type);
      const gtEditor = UnitGreaterThanComparatorEditor.createFor(type);

      // exports[`${key}GreaterThanComparator`] = gtModel
      Plugins.add('AttributeConditionComparator', gtModel);
      Plugins.add('AttributeConditionComparatorEditor', {
        type: gtModel.TYPE,
        editor: gtEditor
      });
      Plugins.add('ConditionEvaluator', {
        type: gtModel.TYPE,
        evaluator: UnitGreaterThanComparatorEvaluator
      });
      const gteModel = UnitGreaterThanOrEqualComparator.createFor(type);
      const gteEditor = UnitGreaterThanOrEqualComparatorEditor.createFor(type);

      // exports[`${key}GreaterThanOrEqualComparator`] = gteModel
      Plugins.add('AttributeConditionComparator', gteModel);
      Plugins.add('AttributeConditionComparatorEditor', {
        type: gteModel.TYPE,
        editor: gteEditor
      });
      Plugins.add('ConditionEvaluator', {
        type: gteModel.TYPE,
        evaluator: UnitGreaterThanOrEqualComparatorEvaluator
      });
      const ltModel = UnitLessThanComparator.createFor(type);
      const ltEditor = UnitLessThanComparatorEditor.createFor(type);

      // exports[`${key}LessThanComparator`] = ltModel
      Plugins.add('AttributeConditionComparator', ltModel);
      Plugins.add('AttributeConditionComparatorEditor', {
        type: ltModel.TYPE,
        editor: ltEditor
      });
      Plugins.add('ConditionEvaluator', {
        type: ltModel.TYPE,
        evaluator: UnitLessThanComparatorEvaluator
      });
      const lteModel = UnitLessThanOrEqualComparator.createFor(type);
      const lteEditor = UnitLessThanOrEqualComparatorEditor.createFor(type);

      // exports[`${key}LessThanOrEqualComparator`] = lteModel
      Plugins.add('AttributeConditionComparator', lteModel);
      Plugins.add('AttributeConditionComparatorEditor', {
        type: lteModel.TYPE,
        editor: lteEditor
      });
      Plugins.add('ConditionEvaluator', {
        type: lteModel.TYPE,
        evaluator: UnitLessThanOrEqualComparatorEvaluator
      });
      const btModel = UnitBetweenComparator.createFor(type);
      const btEditor = UnitBetweenComparatorEditor.createFor(type);

      // exports[`${key}BetweenComparator`] = btModel
      Plugins.add('AttributeConditionComparator', btModel);
      Plugins.add('AttributeConditionComparatorEditor', {
        type: btModel.TYPE,
        editor: btEditor
      });
      Plugins.add('ConditionEvaluator', {
        type: btModel.TYPE,
        evaluator: UnitBetweenComparatorEvaluator
      });
      const neModel = UnitNotEqualsComparator.createFor(type);
      const neEditor = UnitNotEqualsComparatorEditor.createFor(type);

      // exports[`${key}NotEqualsComparator`] = neModel
      Plugins.add('AttributeConditionComparator', neModel);
      Plugins.add('AttributeConditionComparatorEditor', {
        type: neModel.TYPE,
        editor: neEditor
      });
      Plugins.add('ConditionEvaluator', {
        type: neModel.TYPE,
        evaluator: UnitNotEqualsComparatorEvaluator
      });
    });
  }
};